import {
  Box,
  Select,
  Grid,
  MenuItem,
  FormControl,
  OutlinedInput,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CloseIcon from "@mui/icons-material/Close";
import excelIcon from "../../../assets/excel.png";
import IconButton from "@mui/material/IconButton";
import "./uploadTemplateData.scss";
import { useDispatch } from "react-redux";
import * as acts from "../../../redux/pre_processor/actions";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ProgressBar from "../../../components/ProgressBar";
import ProjectHeader from "../../../components/Header/ProjectHeader";
import ProjectStepper from "../../../components/Stepper/ProjectStepperCpvAuto";
import constants from "../../../constants/constantValues";
import PreviewIcon from "@mui/icons-material/Preview";
import { FilesPreview } from "./FilesPreview";
import { preProRoutes } from "../../../routes/routeConstants";

const UploadTemplateData = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uploadedTemplateAndParameters = useSelector(
    (state) => state?.prePro?.uploadedTemplateAndParameters
  );
  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);
  const { DATA_PARAMETER, DATA_FORMAT, QC_TEMPLATE } = constants;
  const [message, setMessage] = useState("");
  const [templateUploadSuccess, setTemplateUploadSuccess] = useState(false);
  const [templateUploadError, setTemplateUploadError] = useState(false);
  const [opDataParameters, setOpDataParameters] = useState({
    loading: false,
    error: false,
    errorMsg: "",
    data: [],
  });
  const [opDataFormat, setOpDataFormat] = useState({
    loading: false,
    error: false,
    errorMsg: "",
    data: [],
  });

  const [selectedData, setSelectedData] = useState({
    templateName: "",
    templatePath: "",
    opFormatName: "",
    opFormatPath: "",
    qcTemplateName: "",
    qcTemplatePath: "",
  });
  const fileType = "templates";
  // const qcFileType = "qc_template";
  const subFolder = localStorage.drugType;
  const drugType = useSelector((state) => state?.prePro?.drugType);
  const outpuFormat = useSelector((state) => state?.prePro?.outpuFormat);
  // const [actionType, setActionType] = useState("");
  const qcFormat = useSelector((state) => state?.prePro?.drugType);
  const [qcTemplateFormat, setQcTemplateFormat] = useState({
    loading: false,
    error: false,
    errorMsg: "",
    data: [],
  });
  const [openFilePreview, setOpenFilePreview] = useState(false);
  const [filePath, setFilePath] = useState({});

  const projectType = localStorage.getItem("projectType") || "";

  const StyledCard = styled(Card)({
    maxWidth: "600px ",
    background: "#D9F5D0",
    border: "1px solid #ECECEC",
    borderRadius: "10px",
    marginTop: "15px",
    height: "50px",
    paddingBottom: "20px",
    paddingRight: "10px",
    paddingLeft: "10px",
  });

  useEffect(() => {
    dispatch(acts.getUploadedTemplateAndOpFormat(localStorage.projectId));
    dispatch(acts.clearApiStatus());
    dispatch(acts.getS3Files(fileType, subFolder));
    dispatch(acts.getOutputformat(subFolder));
    // dispatch(acts.getQcTemplateFormat(subFolder, qcFileType));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (uploadedTemplateAndParameters) {
      setSelectedData({
        ...selectedData,
        templateName: uploadedTemplateAndParameters?.template,
        templatePath: uploadedTemplateAndParameters?.template_path,
        opFormatName: uploadedTemplateAndParameters?.output_format,
        opFormatPath: uploadedTemplateAndParameters?.op_file_path,
        qcTemplateName:
          uploadedTemplateAndParameters?.qc_questions_file_name || "",
        qcTemplatePath:
          uploadedTemplateAndParameters?.qc_questions_file_path || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedTemplateAndParameters]);

  useEffect(() => {
    if (apiStatus.apiSuccess === true && apiStatus?.next === true) {
      setTemplateUploadSuccess(true);
      setMessage(apiStatus.message);
      setTimeout(() => {
        // navigate("/map-data");
        navigate(`/${preProRoutes.mapData}`);
      }, 2000);
      dispatch(acts.clearApiStatus());
    } else if (apiStatus?.apiError === true) {
      setMessage(apiStatus.message);
      setTemplateUploadError(true);
      dispatch(acts.clearApiStatus());
    }

    if (drugType?.data && drugType?.data?.length) {
      setOpDataParameters({
        loading: false,
        error: false,
        errorMsg: "",
        data: drugType,
      });
    }
    if (outpuFormat && outpuFormat.length) {
      setOpDataFormat({
        loading: false,
        error: false,
        errorMsg: "",
        data: outpuFormat,
      });
    }
    if (qcFormat && qcFormat?.data?.length) {
      setQcTemplateFormat({
        loading: false,
        error: false,
        errorMsg: "",
        data: qcFormat?.data,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiStatus, drugType, outpuFormat, qcFormat]);

  const handleTemplateMenuClick = (templateName, templatePath) => {
    setSelectedData({
      ...selectedData,
      templateName: templateName,
      templatePath: templatePath,
      opFormatName: "",
      opFormatPath: "",
    });
  };

  const handleQCTemplateMenuClick = (templateName, templatePath) => {
    setSelectedData({
      ...selectedData,
      qcTemplateName: templateName,
      qcTemplatePath: templatePath,
    });
  };

  const handleOpFormatMenuClick = (opFormatName, opFormatPath) => {
    setSelectedData({
      ...selectedData,
      opFormatName: opFormatName,
      opFormatPath: opFormatPath,
    });
  };

  const onClick = (event, type) => {
    //upload template
    // setActionType(type);
    if (type === "save") {
      dispatch(
        acts.uploadTemplateAndOpFormat({
          ...selectedData,
          projectId: localStorage.projectId,
          next: false,
          projectType,
        })
      );
    } else if (type === "continue") {
      if (isNextDisable()) {
        navigate(`/${preProRoutes.mapData}`);
      } else
        dispatch(
          acts.uploadTemplateAndOpFormat({
            ...selectedData,
            projectId: localStorage.projectId,
            next: true,
            projectType,
          })
        );
    } else if (type === "previous") {
      // navigate("/upload-batch-record");
      navigate(`/${preProRoutes.uploadBatchRecord}`);
    }
  };

  const isNextDisable = () => {
    let isDisable = false;
    // const projectType = localStorage?.projectType;
    // const qcMappingStatus = localStorage?.qc_mapping_status;
    // const templateMappingStatus = localStorage?.template_mapping_status;
    const { projectType, qc_mapping_status, template_mapping_status } =
      localStorage || {};

    if (qc_mapping_status === "done" || template_mapping_status === "done") {
      if (projectType === "both") {
        if (
          qc_mapping_status === "done" &&
          template_mapping_status === "done"
        ) {
          isDisable = true;
        }
      } else if (projectType === "free_form") {
        if (qc_mapping_status === "done") {
          isDisable = true;
        }
      } else if (projectType === "template_driven") {
        if (template_mapping_status === "done") {
          isDisable = true;
        }
      }
    } else if (projectType === "template_driven") {
      isDisable =
        selectedData?.templateName === "" || selectedData?.opFormatName === "";
    } else if (projectType === "free_form") {
      isDisable = selectedData?.qcTemplateName === "";
    } else if (projectType === "both") {
      isDisable =
        selectedData?.templateName === "" ||
        selectedData?.opFormatName === "" ||
        selectedData?.qcTemplateName === "";
    }

    return isDisable;
  };

  const onClickOpenFilePreview = (data) => {
    setFilePath(data);
    setOpenFilePreview(true);
  };

  const onCloseFilePreview = () => {
    setOpenFilePreview(false);
    setFilePath("");
  };
  return (
    <div>
      <Header></Header>
      <ProjectStepper currentStep={2} />
      <ProjectHeader
        position="center"
        headerColor="#F5F5F5"
        text={localStorage.projectName + "-" + localStorage.drugType}
      />
      <Box>
        <Grid
          container
          className={`upload-template-wrap
        ${projectType === "free_form" ? "disabled" : ""}`}
        >
          {/*  Select Input Schema */}
          <Grid item className="upload-template-info">
            <Typography className="uploadpdf-text" variant="subtitle2">
              {DATA_PARAMETER}
            </Typography>
            <FormControl
              fullWidth={true}
              // disabled={localStorage.mapData ? true : false}
            >
              <Select
                disabled={
                  localStorage?.projectType === "free_form" ||
                  localStorage?.template_mapping_status === "done"
                    ? // ||
                      // (localStorage?.mapData === "false" &&
                      //   projectType === "free_form")
                      // (projectType !== "template_driven" ||
                      //   projectType === "both")) // Disable if mapData is false and extraction is false
                      true
                    : false
                }
                className={`upload-select-dropdown ${
                  // projectType !== "template_driven" ? "disable" : ""
                  projectType === "free_form" ? "disable" : ""
                } `}
                labelId="data_param_upload"
                id="data_param_upload"
                placeholder="select"
                value={selectedData?.templateName}
                input={<OutlinedInput />}
                label="Select File"
              >
                {opDataParameters &&
                  opDataParameters?.data?.data?.map((name, index) => (
                    <MenuItem
                      key={name?.file_name}
                      value={name?.file_name}
                      onClick={(e) =>
                        handleTemplateMenuClick(name.file_name, name.file_url)
                      }
                    >
                      {name?.file_name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {selectedData?.templateName && (
              <StyledCard className="uploadTemplate-card">
                <CardHeader
                  className="template-name-style"
                  avatar={<img alt="xlsx" src={excelIcon}></img>}
                  action={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <IconButton
                        aria-label="preview"
                        onClick={() => {
                          // preview logic here
                        }}
                        disabled={
                          localStorage?.projectType === "free_form" ||
                          localStorage?.template_mapping_status === "done"
                        }
                      >
                        <PreviewIcon
                          onClick={() =>
                            onClickOpenFilePreview({
                              template_path: selectedData.templatePath,
                            })
                          }
                        />
                        {/* Use an appropriate icon like VisibilityIcon */}
                      </IconButton>

                      <IconButton
                        aria-label="settings"
                        disabled={
                          // localStorage?.mapData === "false" ? false : true
                          localStorage?.projectType === "free_form" ||
                          localStorage?.template_mapping_status === "done"
                        }
                      >
                        <CloseIcon
                          onClick={() =>
                            setSelectedData({
                              ...selectedData,
                              templateName: "",
                              templatePath: "",
                              opFormatName: "",
                              opFormatPath: "",
                              qcTemplateName: "",
                              qcTemplatePath: "",
                            })
                          }
                        />
                      </IconButton>
                    </Box>
                  }
                  subheader={selectedData?.templateName}
                />
                <CardActions disableSpacing></CardActions>
              </StyledCard>
            )}
          </Grid>

          {/* Select Output Schema */}
          <Grid item className="upload-template-info">
            <Typography className="uploadpdf-text" variant="subtitle2">
              {DATA_FORMAT}
            </Typography>
            <FormControl fullWidth={true}>
              <Select
                labelId="data_format_upload"
                disabled={
                  !selectedData?.templateName ||
                  localStorage?.projectType === "free_form" ||
                  localStorage?.template_mapping_status === "done"

                  // ? //  ||
                  // localStorage?.mapData === "true"
                  //   true
                  // : false
                }
                id="data_format_upload"
                placeholder="select"
                value={selectedData?.opFormatName}
                input={<OutlinedInput />}
                className="upload-select-dropdown"
              >
                {opDataFormat &&
                  opDataFormat?.data?.map((name, index) => (
                    <MenuItem
                      key={name?.file_name}
                      value={name?.file_name}
                      onClick={(e) =>
                        handleOpFormatMenuClick(name.file_name, name.file_url)
                      }
                    >
                      {name?.file_name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {selectedData?.opFormatName && (
              <StyledCard className="uploadTemplate-card">
                <CardHeader
                  className="template-name-style"
                  avatar={<img alt="xlsx" src={excelIcon}></img>}
                  action={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <IconButton
                        aria-label="preview"
                        onClick={() => {
                          // preview logic here
                        }}
                        disabled={
                          localStorage?.projectType === "free_form" ||
                          localStorage?.template_mapping_status === "done"
                        }
                      >
                        <PreviewIcon
                          onClick={() =>
                            onClickOpenFilePreview({
                              op_file_path: selectedData.opFormatPath,
                            })
                          }
                        />
                        {/* Use an appropriate icon like VisibilityIcon */}
                      </IconButton>

                      <IconButton
                        aria-label="settings"
                        disabled={
                          localStorage?.projectType === "free_form" ||
                          localStorage?.template_mapping_status === "done"

                          // ? false : true
                        }
                      >
                        <CloseIcon
                          // className="close-icon-style"
                          onClick={() =>
                            setSelectedData({
                              ...selectedData,
                              opFormatName: "",
                            })
                          }
                        />
                      </IconButton>
                    </Box>
                  }
                  subheader={selectedData?.opFormatName}
                />
                <CardActions disableSpacing></CardActions>
              </StyledCard>
            )}
          </Grid>
        </Grid>

        {/* Import QC Template */}
        <Grid
          container
          className={`upload-template-wrap ${
            projectType === "template_driven" ? "disabled" : ""
          }`}
        >
          <Grid item className="upload-template-info">
            <Typography className="uploadpdf-text" variant="subtitle2">
              {QC_TEMPLATE}
            </Typography>
            <FormControl
              fullWidth={true}
              // disabled={localStorage.mapData ? true : false}
            >
              <Select
                disabled={
                  localStorage?.projectType === "template_driven" ||
                  localStorage?.qc_mapping_status === "done"
                  // ? // ||
                  // (localStorage?.mapData === "false" &&
                  //   projectType === "template_driven")
                  //   true
                  // : false
                }
                className="upload-select-dropdown"
                labelId="qc_template_upload"
                id="qc_template_upload"
                placeholder="select"
                value={selectedData?.qcTemplateName}
                input={<OutlinedInput />}
                label="Select File"
              >
                {qcTemplateFormat?.data?.map((name) => (
                  <MenuItem
                    key={name?.file_name}
                    value={name?.file_name}
                    onClick={(e) =>
                      handleQCTemplateMenuClick(name.file_name, name.file_url)
                    }
                  >
                    {name?.file_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {selectedData?.qcTemplateName && (
              <StyledCard
                className={`uploadTemplate-card`}
                // className={`uploadTemplate-card ${
                //   localStorage?.mapData === "true" ? "disabled" : ""
                // }`}
              >
                <CardHeader
                  className="template-name-style"
                  avatar={<img alt="xlsx" src={excelIcon}></img>}
                  action={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <IconButton
                        aria-label="preview"
                        onClick={() => {
                          // preview logic here
                        }}
                        disabled={
                          localStorage?.projectType === "template_driven" ||
                          localStorage?.template_mapping_status === "done"
                        }
                      >
                        <PreviewIcon
                          onClick={() =>
                            onClickOpenFilePreview({
                              qc_questions_file_path:
                                selectedData.qcTemplatePath,
                            })
                          }
                        />
                        {/* Use an appropriate icon like VisibilityIcon */}
                      </IconButton>

                      <IconButton
                        aria-label="settings"
                        disabled={
                          localStorage?.projectType ===
                            "template_driven" ||
                          localStorage?.qc_mapping_status === "done"
                          // ? true : false
                        }
                      >
                        <CloseIcon
                          onClick={() =>
                            setSelectedData({
                              ...selectedData,
                              qcTemplateName: "",
                              qcTemplatePath: "",
                            })
                          }
                        />
                      </IconButton>
                    </Box>
                  }
                  subheader={selectedData?.qcTemplateName}
                />
                <CardActions disableSpacing></CardActions>
              </StyledCard>
            )}
          </Grid>
        </Grid>

        <div>
          {apiStatus && apiStatus.loader ? <ProgressBar /> : ""}

          {templateUploadSuccess && (
            <CustomizedSnackbars
              severity="success"
              state={templateUploadSuccess}
              text={message}
              handleClose={() => setTemplateUploadSuccess(false)}
            />
          )}

          {templateUploadError && (
            <CustomizedSnackbars
              severity="error"
              state={templateUploadError}
              text={message}
              handleClose={() => setTemplateUploadError(false)}
            />
          )}
        </div>
      </Box>
      {openFilePreview && (
        <FilesPreview
          openFilePreview={openFilePreview}
          closeFilePreview={() => onCloseFilePreview()}
          filePath={filePath}
        />
      )}
      <Footer
        isSaveDisable={
          selectedData?.templateName !== "" && selectedData?.opFormatName === ""
        }
        // isNextDisable={isNextDisable()}
        isPrevious={true}
        onHandleClick={onClick}
      />
    </div>
  );
};
export default UploadTemplateData;
